/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiIntegrationsObjectsIntegrationType } from './WebApiIntegrationsObjectsIntegrationType';
import {
    WebApiIntegrationsObjectsIntegrationTypeFromJSON,
    WebApiIntegrationsObjectsIntegrationTypeFromJSONTyped,
    WebApiIntegrationsObjectsIntegrationTypeToJSON,
} from './WebApiIntegrationsObjectsIntegrationType';
import type { WebApiModelsEnumerationTypesInvoiceStatus } from './WebApiModelsEnumerationTypesInvoiceStatus';
import {
    WebApiModelsEnumerationTypesInvoiceStatusFromJSON,
    WebApiModelsEnumerationTypesInvoiceStatusFromJSONTyped,
    WebApiModelsEnumerationTypesInvoiceStatusToJSON,
} from './WebApiModelsEnumerationTypesInvoiceStatus';

/**
 * 
 * @export
 * @interface WebApiAdminDtoCompanyInvoiceDto
 */
export interface WebApiAdminDtoCompanyInvoiceDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiAdminDtoCompanyInvoiceDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiAdminDtoCompanyInvoiceDto
     */
    companyId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoCompanyInvoiceDto
     */
    companyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoCompanyInvoiceDto
     */
    invoiceNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoCompanyInvoiceDto
     */
    customerReferenceName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoCompanyInvoiceDto
     */
    customerReferenceAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoCompanyInvoiceDto
     */
    customerReferenceZipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoCompanyInvoiceDto
     */
    customerReferenceCity?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiAdminDtoCompanyInvoiceDto
     */
    subscriptionPriceOverride?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiAdminDtoCompanyInvoiceDto
     */
    integrationPriceOverride?: number | null;
    /**
     * 
     * @type {WebApiIntegrationsObjectsIntegrationType}
     * @memberof WebApiAdminDtoCompanyInvoiceDto
     */
    forceIntegrationType?: WebApiIntegrationsObjectsIntegrationType;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesInvoiceStatus}
     * @memberof WebApiAdminDtoCompanyInvoiceDto
     */
    status?: WebApiModelsEnumerationTypesInvoiceStatus;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoCompanyInvoiceDto
     */
    blobUri?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiAdminDtoCompanyInvoiceDto
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the WebApiAdminDtoCompanyInvoiceDto interface.
 */
export function instanceOfWebApiAdminDtoCompanyInvoiceDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoCompanyInvoiceDtoFromJSON(json: any): WebApiAdminDtoCompanyInvoiceDto {
    return WebApiAdminDtoCompanyInvoiceDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoCompanyInvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoCompanyInvoiceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'invoiceNumber': !exists(json, 'invoiceNumber') ? undefined : json['invoiceNumber'],
        'customerReferenceName': !exists(json, 'customerReferenceName') ? undefined : json['customerReferenceName'],
        'customerReferenceAddress': !exists(json, 'customerReferenceAddress') ? undefined : json['customerReferenceAddress'],
        'customerReferenceZipCode': !exists(json, 'customerReferenceZipCode') ? undefined : json['customerReferenceZipCode'],
        'customerReferenceCity': !exists(json, 'customerReferenceCity') ? undefined : json['customerReferenceCity'],
        'subscriptionPriceOverride': !exists(json, 'subscriptionPriceOverride') ? undefined : json['subscriptionPriceOverride'],
        'integrationPriceOverride': !exists(json, 'integrationPriceOverride') ? undefined : json['integrationPriceOverride'],
        'forceIntegrationType': !exists(json, 'forceIntegrationType') ? undefined : WebApiIntegrationsObjectsIntegrationTypeFromJSON(json['forceIntegrationType']),
        'status': !exists(json, 'status') ? undefined : WebApiModelsEnumerationTypesInvoiceStatusFromJSON(json['status']),
        'blobUri': !exists(json, 'blobUri') ? undefined : json['blobUri'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
    };
}

export function WebApiAdminDtoCompanyInvoiceDtoToJSON(value?: WebApiAdminDtoCompanyInvoiceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'companyId': value.companyId,
        'companyName': value.companyName,
        'invoiceNumber': value.invoiceNumber,
        'customerReferenceName': value.customerReferenceName,
        'customerReferenceAddress': value.customerReferenceAddress,
        'customerReferenceZipCode': value.customerReferenceZipCode,
        'customerReferenceCity': value.customerReferenceCity,
        'subscriptionPriceOverride': value.subscriptionPriceOverride,
        'integrationPriceOverride': value.integrationPriceOverride,
        'forceIntegrationType': WebApiIntegrationsObjectsIntegrationTypeToJSON(value.forceIntegrationType),
        'status': WebApiModelsEnumerationTypesInvoiceStatusToJSON(value.status),
        'blobUri': value.blobUri,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
    };
}

